exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn_confirmar {\n  background-color: rgb(255, 108, 0) !important;\n  border-color: rgb(255, 108, 0) !important;\n}\n", ""]);

// exports
